import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import type { BusinessNote } from '../schemas/note-schema'

interface DeleteNoteParams {
  id: number
  referralShareId?: number
  leadInquiryId?: number
}

const deleteNote = async (id: number): Promise<BusinessNote | undefined> => {
  return deleteRequest<BusinessNote>(`/business/notes/${id}`)
}

/**
 * Hook to delete a note
 */
export const useDeleteNote = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: DeleteNoteParams) => deleteNote(id),
    onSuccess: (_, { referralShareId, leadInquiryId, id }) => {
      // Invalidate the notes list query to trigger a refetch
      if (referralShareId) {
        queryClient.invalidateQueries({
          queryKey: queries.notes.list({ referralShareId }).queryKey,
        })
      }
      if (leadInquiryId) {
        queryClient.invalidateQueries({
          queryKey: queries.notes.list({ leadInquiryId }).queryKey,
        })
      }

      // Invalidate the specific note query too
      queryClient.invalidateQueries({
        queryKey: queries.notes.details(id).queryKey,
      })
    },
  })
}
